// extracted by mini-css-extract-plugin
export default {"pillContainer":"ProjectSummary_pillContainer__p18Mx","projectSection":"ProjectSummary_projectSection__IU2ev"};